<template>
  <div
    v-if="visible"
    class="eligibility-notice"
    role="status"
  >
    <button
      class="close"
      type="button"
      aria-label="Close"
      @click="dismiss"
    >
      ×
    </button>
    <b>Outside the eligible category</b>
    <p>
      Based on the details you registered with, you are competing outside
      of the official ranking. If this is a mistake, join our
      <a
        href="https://discord.gg/m6pcEYp"
        target="_blank"
        rel="noopener"
      >Discord</a>
      and open a ticket.
    </p>
  </div>
</template>

<script>
// Closing it only hides it until the next visit, it is meant as a reminder.
const DISMISS_KEY = 'eligibility-notice-dismissed'

export default {
    data () {
        let dismissed = false
        try {
            dismissed = sessionStorage.getItem(DISMISS_KEY) === '1'
        } catch (e) {}
        return { dismissed }
    },
    computed: {
        visible () {
            const user = this.$store.state.user
            return !this.dismissed && !!user && !!user.outside_eligible
        },
    },
    methods: {
        dismiss () {
            this.dismissed = true
            try {
                sessionStorage.setItem(DISMISS_KEY, '1')
            } catch (e) {}
        },
    },
}
</script>

<style lang="scss" scoped>
.eligibility-notice {
    @include mc-tooltip(0.96);
    @include mc-frame($ssm-gold);
    position: relative;
    display: inline-block;
    max-width: min(26rem, calc(100vw - 3rem));
    margin-bottom: 1.5rem;
    padding: 0.6rem 2.5rem 0.6rem 1rem;
    text-align: left;
    animation: slidein 0.4s steps(4, end);

    b {
        display: block;
        font-weight: 700;
        color: #ffff55;
    }

    p {
        margin: 0.25rem 0 0;
        color: $ssm-muted;
    }
}

.close {
    position: absolute;
    top: 0.2rem;
    right: 0.5rem;
    padding: 0 0.25rem;
    border: none;
    background: none;
    color: $ssm-muted;
    font-family: inherit;
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;

    &:hover,
    &:focus-visible {
        color: $color-white;
    }
}

@keyframes slidein {
    from {
        opacity: 0;
        transform: translateX(110%);
    }
    to {
        opacity: 1;
        transform: none;
    }
}
</style>
